module.exports = "/images/outline-expand_less-24px.svg?fce4858df246044ef0e5604e2d3f2f09";